import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";
import {AgentsService} from "../../../agents/services/agents-service.service";
import {AgentDialogService} from "../../../agents/services/agent-dialogs-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {ScheduleDialogService} from "../../services/schedule-dialog.service";
import {ScheduleService} from "../../services/schedule-service.service";

export class ScheduleTemplatesViewComponent implements IController {
  templates: any;
  selectedTemplate: any;

  private loadingAgents: boolean = false;
  private agents: any = [];
  private events: any = [];
  private schedule: any = [];
  private from: any = undefined;
  private to: any = undefined;
  private agentPanelOpen: any = undefined;
  private queryString: any = undefined;
  private columnFormat: any;
  dateFormat: any;
  private views: any;
  private canCreate: any;
  private canUpdate: any;
  private canDelete: any;

  constructor(private scheduleDialogService: ScheduleDialogService, private confirmDialogService: ConfirmDialogService, private splitService, private $state, private $mdMedia, private commonsService: CommonsService,
              private commonsDialogService: CommonsDialogService, private IAMPermissions, private $log, private scheduleService: ScheduleService, private agentsService: AgentsService,
              private agentDialogService: AgentDialogService, private $filter, private $q: IQService, private moment) {
    this.dateFormat = this.splitService.getDateAndTimeConfig().long;

  }

  $onInit() {

    this.agentPanelOpen = this.$mdMedia('gt-sm');
    this.columnFormat = 'ddd ' + this.dateFormat;

    //This Week View
    // this.minDate = moment().startOf('week');
    // this.maxDate = moment().endOf('week');

    // this.dateFormat = splitService.getDateAndTimeConfig().long;
    // this.firstDay = splitService.getDateAndTimeConfig().firstDay;
    this.views = ['agendaWeek', 'agendaDay'];

    this.canCreate = this.IAMPermissions.hasPermission('schedule.template.create');
    this.canUpdate = this.IAMPermissions.hasPermission('schedule.template.update');
    this.canDelete = this.IAMPermissions.hasPermission('schedule.template.delete');


    // The init if from the calendar days selection!
    // if (ctrl.selectedTemplate) {
    //     _getTemplateSchedule(ctrl.selectedTemplate.id);
    //     _getTemplateAgents(ctrl.selectedTemplate.id);
    // }
  }

  onChangeTemplate(template) {
    if (_.get(template, 'id') !== _.get(this.selectedTemplate, 'id')) {
      this.selectedTemplate = template;
      this.getTemplateSchedule(template.id, this.from, this.to);
      this.getTemplateAgents(template.id);
      this.$state.go('.', {templateId: template.id}, {notify: false, reload: false, location: 'replace'})
    }
  }

  onCreateTemplate($event) {
    this.scheduleDialogService.createTemplate($event)
      .then((template) => {
        this.createTemplate(template);
      })
  }

  onEditTemplate($event) {
    this.scheduleDialogService.createTemplate($event, this.selectedTemplate)
      .then((template) => {
        this.updateTemplate(template);
      })
  }

  onDeleteTemplate(templateId, $event) {
    const text = 'Are you sure you want to delete template?';
    this.confirmDialogService.confirm('Confirm', text, $event)
      .then(() => {
        this.deleteTemplate(templateId);
      });
  }

  onEditDragSchedule(scheduleEvent, $event, revertFunc) {
    const eventInstanceFromDate = scheduleEvent.start.valueOf();
    let changeType;
    const scheduleRef = scheduleEvent.dataRef;
    const functionRef = scheduleRef.schedule.freq ? this.scheduleDialogService.selectChangeType($event) : this.$q.when()

    functionRef
      .then((selectedChangeType) => {
        // # EVENT # FUTURE # ALL
        changeType = selectedChangeType || 'EVENT';
        return this.$q.when(scheduleRef)
      })
      .then((editedSchedule) => {
        this.updateTemplateSchedule(editedSchedule, changeType, eventInstanceFromDate);
      })
      .catch(() => {
        if (revertFunc) {
          revertFunc();
        }
        this.$log.info('Dialog Closed');
      });
  }

  onEditSchedule(scheduleEvent, $event, revertFunc?) {
    const scheduleRef = scheduleEvent.dataRef;
    const eventInstanceFromDate = scheduleEvent.start.valueOf();
    const eventInstanceToDate = scheduleEvent.end.valueOf();

    this.scheduleDialogService.edit($event, scheduleRef, eventInstanceFromDate, eventInstanceToDate, _.get(this.selectedTemplate, 'zoneId'))
      .then((payload) => {
        this.updateTemplateSchedule(payload.schedule, payload.changeType, eventInstanceFromDate);
      })
      .catch(() => {
        if (revertFunc) {
          revertFunc();
        }
        this.$log.info('Dialog Closed');
      });
  }

  onDeleteSchedule(scheduleEvent, $event) {
    let eventInstanceDate;
    let changeType;
    const scheduleRef = scheduleEvent.dataRef;
    const functionRef = scheduleRef.schedule.freq ? this.scheduleDialogService.selectChangeType($event) : this.$q.when()

    functionRef
      .then((selectedChangeType) => {
        // # EVENT # FUTURE # ALL
        changeType = selectedChangeType || 'EVENT';

        if (changeType === 'EVENT' || changeType === 'FUTURE') {
          eventInstanceDate = scheduleEvent.start.valueOf();
        }

        this.deleteSchedule(scheduleRef.id, changeType, eventInstanceDate);
        // _updateOneSchedule(editedSchedule, changeType, eventInstanceDate);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      });
  }

  onViewRender(start, end) {
    const currentStart = start.valueOf();
    const currentEnd = end.valueOf();

    if (this.from !== currentStart || this.to !== currentEnd) {
      this.from = currentStart;
      this.to = currentEnd;

      // this.events = _convertScheduleToEvents(this.schedule);
      this.getTemplateSchedule(this.selectedTemplate.id, this.from, this.to);
      this.getTemplateAgents(this.selectedTemplate.id);
    }
  }

  onCalendarSelection(from, to, $event) {

    // If only clicked on calendar (less then an full hour)
    if (to.valueOf() - from.valueOf() <= 1800000) {
      return;
    }

    let fromTimestamp: number = from.valueOf();
    let toTimestamp: number;

    if (this.moment(to.valueOf()).get('hour') === 0) {
      toTimestamp = to.valueOf() - 900000;
    } else {
      toTimestamp = to.valueOf();
    }

    this.onCreateTemplateSchedule($event, fromTimestamp, toTimestamp);


    // var format = splitService.getDateAndTimeConfig().time,
    //     title = 'Create Schedule, ' + from.format(format) + ' - ' + to.format(format);
    //
    // ConfirmDialog.confirm(title, 'Are you sure you want to create a new schedule?', $event)
    //     .then(function() {
    //         var scheduleToCreate = scheduleService.getSchedulePayload(from.valueOf(), to.valueOf(), from.valueOf());
    //         _createTemplateSchedule(scheduleToCreate);
    //     })
    //     .catch(function(error) {
    //         $log.info('Dialog Closed');
    //     })
  }

  onEventClick(event, $event) {

    if (this.moment(event.start).startOf('day').isBefore(this.moment().startOf('day'))) {
      return;
    }

    const actions = _.chain([
      {key: 'Edit', value: this.canUpdate},
      {key: 'Delete', value: this.canDelete}
    ])
      .filter((a) => {
        return a.value;
      })
      .map((a) => {
        return a.key
      })
      .value();

    this.commonsService.openActionPanel(actions, $event)
      .then((reason) => {
        if (reason === 'Edit') {
          this.onEditSchedule(event, $event);
        }
        if (reason === 'Delete') {
          this.onDeleteSchedule(event, $event);
        }
      })
      .catch((reason) => {
        this.$log.info('Action Panel Closed', reason);
      });
  }

  onEventChange(event, delta, revertFunc, $event) {

    const oneScheduleCopy = angular.copy(event);
    // oneScheduleCopy.schedule.startTime = event.start.valueOf();
    // oneScheduleCopy.schedule.endTime = event.end.valueOf();
    // oneScheduleCopy.schedule.startRecurring = event.start.valueOf();
    // oneScheduleCopy.schedule.dow = [event.start.day()];
    // _updateTemplateSchedule(scheduleCopy);

    if (oneScheduleCopy.start.startOf('day').isBefore(this.moment().startOf('day'))) {
      revertFunc();
      return;
    }


    oneScheduleCopy.dataRef.schedule.startTime = event.start.valueOf();
    oneScheduleCopy.dataRef.schedule.endTime = event.end.valueOf();

    this.onEditDragSchedule(oneScheduleCopy, $event, revertFunc)
  }

  onQueryChange(queryString) {
    this.queryString = queryString;
  }

  onAddAgentToTemplate($event) {
    const attachedAgentIds = _.map(this.agents, 'id');
    let agentRef;
    this.agentDialogService.addAgent($event, attachedAgentIds)
      .then((agent) => {
        agentRef = agent;
        return this.agentsService.selectScheduleTemplate(agent.id, this.selectedTemplate.id);
      })
      .then(() => {
        this.agents = this.agents.concat([agentRef]);
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to select agent template ' +
            '@scheduleTemplatesViewCtrl@onAddAgentToTemplate', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
  }

  onRemoveAgentFromTemplate(agent, event) {
    const text = 'Are you sure you want to remove this agent from template?';
    this.confirmDialogService.confirm('Confirm Remove', text, event)
      .then(() => {
        this.removeAgentFromTemplate(agent.id);
      });
  }

  // ******************************
  //        Private methods
  // ******************************

  private getTemplateSchedule(templateId, from, to) {
    this.scheduleService.getTemplateSchedule(templateId, from, to)
      .then((schedule) => {
        this.schedule = schedule;
        this.events = this.convertScheduleToEvents(schedule);
      })
  }

  private getTemplateAgents(templateId) {
    this.loadingAgents = true;
    this.scheduleService.getTemplateAgents(templateId)
      .then((agents) => {
        this.agents = agents;
      })
      .finally(() => {
        this.loadingAgents = false;
      })
  }

  private createTemplate(template) {
    this.scheduleService.createTemplate(template)
      .then((createdTemplate) => {
        this.selectedTemplate = createdTemplate
        this.schedule = [];
        this.agents = [];
        this.events = [];
      })
  }

  private updateTemplate(template) {
    this.scheduleService.updateTemplate(template)
      .then((updatedTemplate) => {
        this.selectedTemplate = updatedTemplate;
      })
  }

  deleteTemplate(templateId) {
    this.scheduleService.deleteTemplate(templateId)
      .then(() => {
        this.selectedTemplate = undefined;
      })
  }

  private removeAgentFromTemplate(agentId) {
    this.agentsService.selectScheduleTemplate(agentId)
      .then(() => {
        this.agents = _.filter(this.agents, (a) => {
          return a.id !== agentId;
        })
      })
  }

  private onCreateTemplateSchedule($event, from, to) {
    this.scheduleDialogService.create($event, from, to, _.get(this.selectedTemplate, 'zoneId'))
      .then((scheduleToCreate) => {
        this.createSchedule(scheduleToCreate);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      });
    // ScheduleService.createTemplateSchedule(ctrl.selectedTemplate.id, [schedule])
    // .then(function(createdSchedule) {
    //     ctrl.schedule = ctrl.schedule.concat(createdSchedule);
    //     ctrl.events = _convertScheduleToEvents(ctrl.schedule);
    // })
  }

  private createSchedule(schedule) {
    this.scheduleService.createTemplateSchedule(this.selectedTemplate.id, [schedule])
      .then(() => {
        this.getTemplateSchedule(this.selectedTemplate.id, this.from, this.to);
        this.getTemplateAgents(this.selectedTemplate.id);
      })
  }

  private updateTemplateSchedule(schedule, type, eventInstanceDate) {
    this.scheduleService.updateTemplateSchedule(this.selectedTemplate.id, schedule.id, schedule, type, eventInstanceDate)
      .then(() => {
        this.getTemplateSchedule(this.selectedTemplate.id, this.from, this.to);
        this.getTemplateAgents(this.selectedTemplate.id);
      })
  }

  private deleteSchedule(scheduleId, type, eventInstanceDate) {
    this.scheduleService.deleteTemplateSchedule(this.selectedTemplate.id, scheduleId, type, eventInstanceDate)
      .then(() => {
        this.getTemplateSchedule(this.selectedTemplate.id, this.from, this.to);
        this.getTemplateAgents(this.selectedTemplate.id);
      })
  }

  private convertScheduleToEvents(schedule) {
    if (!schedule) {
      return [];
    }

    return this.scheduleService.parseManyScheduleToEventsByRange(schedule, this.from, this.to);
  }

}

angular
  .module('bringoz.admin.schedule')
  .component('scheduleTemplatesView', {
    bindings: {
      templates: '<',
      selectedTemplate: '<'
    },
    templateUrl: 'app/modules/schedule/components/schedule-templates-view/schedule-templates-view.html',
    controller: ScheduleTemplatesViewComponent
  });
